// コンテンツ未読情報
export class ContentReadInfo {
  constructor(
    public checkedUntilAt: Date | undefined, // ここまでチェック済み（この日時より新しいコンテンツがチェック対象）
    public lastUnreadBoundaryAt: Date | undefined, // 最後の未読の境界（この日時より古いコンテンツがチェック対象）
  ) {
    this.checkedUntilAt = checkedUntilAt;
    this.lastUnreadBoundaryAt = lastUnreadBoundaryAt;
  }

  public static empty(): ContentReadInfo {
    return new ContentReadInfo(undefined, undefined);
  }
}

// Firestore data converter
export const ContentReadInfoConverter = {
  toFirestore: (contentReadInfo: ContentReadInfo) => {
    const data: any = {};

    if (contentReadInfo.checkedUntilAt) {
      data.last_checked_at = contentReadInfo.checkedUntilAt;
    }
    if (contentReadInfo.lastUnreadBoundaryAt) {
      data.last_unread_at = contentReadInfo.lastUnreadBoundaryAt;
    }

    return data;
  },
  fromFirestore: (snapshot: any, options: any) => {
    const data = snapshot.data(options);
    return new ContentReadInfo(
      data.last_checked_at ? data.last_checked_at.toDate() : undefined,
      data.last_unread_at ? data.last_unread_at.toDate() : undefined,
    );
  },
};
